<template>
  <div class="text-static-default-low">
    <p v-if="withCancel" class="caption">
      <FormattedMessage
        :definition="translations.cancel"
        :values="{ days: coolingOffDays }"
      >
        <template #link>
          <RevLink
            target="_blank"
            :to="`${baseUrlWithLocale}/${CMS.LEGAL_PAGE}/${LEGAL_PAGE_NAME.TERMS_SALE}`"
          >
            {{ i18n(translations.cancelLink, { days: coolingOffDays }) }}
          </RevLink>
        </template>
      </FormattedMessage>
    </p>

    <p class="caption">
      <FormattedMessage :definition="text">
        <template #useTerms>
          <RevLink
            target="_blank"
            :to="`${baseUrlWithLocale}/${CMS.LEGAL_PAGE}/${LEGAL_PAGE_NAME.TERMS_USE}`"
          >
            {{ i18n(translations.useTermsLink) }}
          </RevLink>
        </template>
        <template #saleTerms>
          <RevLink
            target="_blank"
            :to="`${baseUrlWithLocale}/${CMS.LEGAL_PAGE}/${LEGAL_PAGE_NAME.TERMS_SALE}`"
          >
            {{ i18n(translations.saleTermsLink) }}
          </RevLink>
        </template>
        <template #swap>
          <RevLink
            v-if="withSwap"
            target="_blank"
            :to="`${baseUrlWithLocale}/${CMS.LEGAL_PAGE}/${LEGAL_PAGE_NAME.BUYBACK}`"
          >
            {{ i18n(translations.swapLink) }}
          </RevLink>
        </template>
        <template #privacy>
          <RevLink
            anchor
            target="_blank"
            :to="`${baseUrlWithLocale}/${CMS.LEGAL_PAGE}/${LEGAL_PAGE_NAME.DATA_PROTECTION}`"
          >
            {{ i18n(translations.privacyLink) }}
          </RevLink>
        </template>
        <template #termsOfService>
          <RevLink
            anchor
            target="_blank"
            :to="`${baseUrlWithLocale}/${CMS.LEGAL_PAGE}/${LEGAL_PAGE_NAME.TERMS_SERVICE}`"
          >
            {{ i18n(translations.termsOfServiceLink) }}
          </RevLink>
        </template>
      </FormattedMessage>
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketBaseUrl } from '@backmarket/nuxt-module-marketplace/useMarketBaseUrl'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevLink } from '@ds/components/Link'

import { CMS, LEGAL_PAGE_NAME } from './CheckoutLegalLinks.constants'
import translations from './CheckoutLegalLinks.translations'

const i18n = useI18n()
const { features } = useMarketplace()
const { coolingOffDays } = features
const { baseUrlWithLocale } = useMarketBaseUrl('main')

const props = withDefaults(
  defineProps<{
    withCancel?: boolean
    withSwap?: boolean
  }>(),
  {
    withCancel: false,
    withSwap: false,
  },
)

const text = computed(() => {
  return props.withSwap ? translations.textWithSwap : translations.text
})
</script>
